import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';

import OrderList from './OrderList';
import EmptyList from './EmptyList';

import './Orders.css';

const Orders: React.FC = () => {
  const { orders, orderHistory } = useSelector((state: RootState) => state.trading);
  const [activeTab, setActiveTab] = useState<'active' | 'history'>('active');

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 2,
    }).format(amount);
  };

  const activeOrders = orders.filter(order => order.status === 'open');
  const closedOrders = orderHistory.filter(order => order.status === 'closed');

  return (
    <div className="orders">
      {/* Tabs */}
      <div className="orders__header">
        <button
          className={`orders__button orders__active-button ${activeTab === 'active' ? 'active' : ''}`}
          onClick={() => setActiveTab('active')}
        >
          Active Orders<span className="orders__active-value">{activeOrders.length}</span>
        </button>

        <button
          className={`orders__button orders__history-button ${activeTab === 'history' ? 'active' : ''}`}
          onClick={() => setActiveTab('history')}
          data-label="History"
        >
          History
        </button>
      </div>

      {/* Content */}
      {activeTab === 'active' ? (
        <>
          {activeOrders.length === 0 ? (
            <EmptyList
              text='No active orders'
              desc='Open a position to start trading'
            />
          ) : (
            <OrderList orders={activeOrders} />
          )}
        </>
      ) : (
        <>
          {closedOrders.length === 0 ? (
            <EmptyList
              text='History is empty'
              desc='Closed orders will appear here'
            />
          ) : (
            <OrderList orders={closedOrders} />
          )}
        </>
      )}
    </div>
  );
};

export default Orders;
